import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import { PlusOutlined,CloseOutlined,FileImageOutlined,VideoCameraOutlined } from '@ant-design/icons';
import ModalImage from "react-modal-image";
import axios from 'axios';
import $ from 'jquery';

import attached from '../../assets/images/icon/paperclip.png';


const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}



function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const storedFiles=[];

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			previewVisible: false,
			previewImage: '',
			previewTitle: '',
			imageUrl: '',
			fileList: [],
			category_list: [],
			payee_list: [],
			category_details: [],
			loading: false,
			value: '',
			visible: '',
			visible_category: '',
			payee: '',
			visible1: '',
			visible2: '',
			visible3: '',			
			file1:null,	
			title: '',
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.goBack = this.goBack.bind(this);
	}


	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });		
	};
	  
  	file_preview1 = (e) => {
		let file1 = e.target.files[0];
		if(file1.size<=1024000){	
		 $('#file_preview1').html('1 file selected');
		 this.setState({ file1: e.target.files[0]});		
		}
		else{
		 message.config({ top: 150});
		 message.error('Error! Max file size 1MB allowed!');	
		}		
    }
	
  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		const data2 = new FormData() 
		data2.append('title', this.state.title);
		data2.append('file1', this.state.file1);
		data2.append('user_id', this.state.user_id)
		data2.append('school_id', this.state.school_id)
		let doc_url = "https://kcisapi.kidzonia.co.in/v1/erp/store_house_add";	
		axios.post(doc_url, data2, {
		})
		.then(res => {  
		if(res.status==200){
			message.config({ top: 150});
			message.success('Store House added',2);
			this.setState({ loading: false });
			this.setState({comment_text:''});
			window.location.href = '/store-house/index';	
		 }
		 else{
            message.config({ top: 150});
			message.error(res.message,2);
			this.setState({ loading: false });
        }
		 
			
		})
	
	  
	  
	  }else{
		message.error('Please Login',2);	
	  }

  }
	
	goBack(){
		window.location.href = '/store-house/index';
	}
	
	render()

	{

					
		return (
		<div class="mobile_view">
			
		<div id="main" class="bg-off">
         <div class="row">
		  <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					  <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Add Store House</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/store-house/index">Store House</a>
                           </li>
                           <li class="breadcrumb-item active">Add Store House
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
            
			 <div class="col s12 m12 ex-padd">
            <div class="container view-Profile child-profile view-Profile-mobile">
			   <div class="col s12 m12 mb-20 iq-card card card-content iq-card">
                  <section class="invoice-list-wrapper section food ">
					<div class="children mb-20 iq-card2 flow-root">
                    
						<div class="bb d-flex">						  
						  <div class="col m12 pl-0">
								<div class="col m8 s12 mb-10 mt-10">
									<label>Title</label>
									<input type="text" name="title" id="title" onChange={this.handleSizeChange}   />
								</div>	
								<div class="col m4 s12 mt-10 mb-10">
								</div>	
						
								<div class="col m12 s12 pb-10 mb-10">
									<div class="post-block">
										<label class="b-10 control-label">Attachment* 
									     <br/><small>(Accepts - .png, .jpg, .jpeg, .pdf, .docx only & max-1MB) </small></label>
										<div class="post-block upload_img">											
											<label class="ant-btn snd-btn ipt-10" for="file1" id="file_preview1">Choose File</label>
											<input id="file1" type="file" accept=".png, .jpg, .jpeg,.pdf,.docx" name="file1" onChange={this.file_preview1.bind(this)} style={{display: 'none',opacity: '0'}}/>
										</div>
									</div>		
								</div>
						  </div>
						</div>
					</div> 
		

				

					
					
					
					<div class="col m12 s12 meal mb-20 center">
						 <Button className="cancel-btn large-btn" onClick={this.goBack}>Back</Button>
						 <Button className="snd-btn large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
